import { useAppContext } from '@contexts/AppContext';

export const TARGET_APP_VERSION = 3;

export function getNativeMajorVersion(nativeAppVersion: string) {
  const nativeMajorVersion = nativeAppVersion ? parseInt(nativeAppVersion.split('.')[0], 10) : 0;
  return nativeMajorVersion;
}

export default function useNativeAppVersionCheck() {
  const { isNativeApp, nativeAppVersion } = useAppContext();

  const nativeMajorVersion = getNativeMajorVersion(nativeAppVersion);

  return {
    isApp3_0OrGreater: nativeMajorVersion >= TARGET_APP_VERSION,
    isNativeApp: !!isNativeApp,
  };
}
